// import { useColorScheme as useRNColorScheme } from 'react-native';
import { useEffect, useState } from "react";

/**
 * To support static rendering, this value needs to be re-calculated on the client side for web
 */
export function useColorScheme() {
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  /* Light theme enforced for now */
  // const colorScheme = useRNColorScheme();

  if (hasHydrated) {
    return "light"; // colorScheme;
  }

  return "light";
}
